import LazyLoad from "vanilla-lazyload";
import Flickity from "flickity";

const initLazyload = () => {
    new LazyLoad({
        elements_selector: '.js-lazy',
        threshold: 200,
        callback_loaded: resizeSlider
    })

    let lazyLoadInstances = []
    var initOneLazyLoad = function (horizContainerElement) {

        // Instantiate a new LazyLoad instance specifically for the container
        var oneLL = new LazyLoad({
            container: horizContainerElement,
            elements_selector: "img",
            auto_unobserve: true,  // Stop observing the images after they are loaded
            callback_loaded: (imageElement) => {
                const flickitySlider = imageElement.closest('.flickity-enabled');
                if (flickitySlider) {
                    const flkty = Flickity.data(flickitySlider);
                    if (flkty) {
                        flkty.resize();
                    }
                }
            }
        });

        // Use the LazyLoad API to manually load all images inside the container
        var images = horizContainerElement.querySelectorAll("img");
        images.forEach(img => {
            LazyLoad.load(img)
            resizeSlider(img)
        });

        // Optionally push it in the lazyLoadInstances array to keep track of the instances
        lazyLoadInstances.push(oneLL);
    };

// Setup LazyLoad to detect when sliders enter the viewport
    var lazyLazy = new LazyLoad({
        elements_selector: ".js-lazy-container",
        callback_enter: initOneLazyLoad,
        unobserve_entered: true  // Stop observing the container after it has entered the viewport
    });


}

const resizeSlider = (imageElement) => {
    const flickitySlider = imageElement.closest('.flickity-enabled');
    if (flickitySlider) {
        // Get the Flickity instance from the slider element
        const flkty = Flickity.data(flickitySlider);

        // Check if it's indeed a Flickity instance
        if (flkty) {
            // Trigger resize to adjust the slider dimensions
            flkty.resize();
        }
    }
}

export {initLazyload}
